import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'

import actionProptypes from '../../actions/proptypes'

import { Container as Grid } from 'react-bootstrap'
import { Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'

import {
  LoadableLCRPSplitPane,
  LoadableStudentInsights
} from '../../../shared/components/Loadable'
import TopBar from '../../../client/components/TopBar'
import AssignmentReadingMobile from '../AssignmentReadingMobile'
import StudentProgressBar from '../StudentProgressBar'
import CheckYourUnderstandingModal from '../CheckYourUnderstandingModal'
import TextTruncate from '../../../shared/components/TextTruncate'
import CloseX from '../../../shared/components/CloseX'
import QuizProgressArea from '../QuizProgressArea'
import AutoFocus from '../AutoFocus'
import MobileNavDropdown from '../../../shared/components/MobileNavDropdown'
import PreviewAsStudentModal from '../PreviewAsStudentModal'
import HowIsCalculatedModal from '../../../client/components/Instructor/HowIsCalculatedModal'
import RestrictableButton from '../../../shared/components/Instructor/RestrictableButton'

import { getQuestionAccuracy, calculateFirstAttemptAccuracy, calculateRetakeAccuracy } from '../../../shared/lib/calculateAccuracy'
import { createSectionArray, getNextUnreadSectionById, getNextUnreadSection, isRetakeCheck, isInProgressCheck } from '../../lib/parse'

import lockImg from 'Assets/vital-source-lock-icon.svg'

import baseStyle from 'Styles/base.css'
import panelStyle from 'Styles/panel.css'
import style from './style.css'

export default class AssignmentReading extends Component {
  constructor (props) {
    super(props)

    this.onSelectReading = this.onSelectReading.bind(this)
    this.onToggleVitalSourceEbook = this.onToggleVitalSourceEbook.bind(this)
    this.onCloseVitalSourceEbook = this.onCloseVitalSourceEbook.bind(this)
    this.onNextItem = this.onNextItem.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)
    this.onOpenVitalSourceNewTab = this.onOpenVitalSourceNewTab.bind(this)
    this.startQuiz = this.startQuiz.bind(this)
    this.startQuizRetake = this.startQuizRetake.bind(this)
    this.openCheckUnderstandingModal = this.openCheckUnderstandingModal.bind(this)
    this.closeCheckUnderstandingModal = this.closeCheckUnderstandingModal.bind(this)
    this.loadNextCyuSection = this.loadNextCyuSection.bind(this)
    this.openStudentInsights = this.openStudentInsights.bind(this)

    this.state = {
      showVitalSourceEbook: false,
      selectedSection: null,
      checkUnderstandingQuestionIndex: 0,
      splitLeftFooterWidth: '50%',
      showInsights: false,
      displayModal: false,
      howIsCalculatedModalOpen: false
    }
  }

  onResizeSplit (newWidth) {
    this.setState({
      splitLeftFooterWidth: newWidth
    })
  }

  onKeyDown (event) {
    if (event.keyCode === 13) {
      event.target.click()
    }
  }

  onNextItem (newId) {
    if (newId !== null) {
      this.onSelectReading(this.props.activity.topics[newId], false, false)
    }
  }

  onOpenVitalSourceNewTab (url) {
    const w = window.open(url)
    w.document.close()
  }

  startQuiz () {
    this.props.onStartQuiz()
  }

  openStudentInsights () {
    if (this.props.previewMode === 'true' || this.props.activity.config.isInstructorView) {
      this.setState({ displayModal: true })
    } else {
      this.setState({ showInsights: true })
      this.props.actions.studentInsightsTrends()
    }
  }

  // Need to add ?demo=1 so that <TopBar /> displays 'Retake' instead of 'Score'
  startQuizRetake () {
    let { origin, search, pathname } = window.location
    if (pathname.includes('/lcrp/')) {
      pathname = pathname.slice(5)
    }
    const activityURL = origin + pathname + search
    const hideStartAppend = window.location.search.length === 0 ? '?hide_start=true&demo=1' : '&hide_start=true&demo=1'
    window.location.href = activityURL + hideStartAppend
  }

  openCheckUnderstandingModal (selectedSection, e) {
    this.props.actions.openCheckUnderstandingModal(selectedSection)
    e.stopPropagation()
  }

  closeCheckUnderstandingModal () {
    const activity = this.props.activity
    const sectionArr = createSectionArray(this.props.activity)
    this.props.actions.closeCheckUnderstandingModal(activity, sectionArr)
  }

  loadNextCyuSection () {
    const activity = this.props.activity
    const sectionArr = createSectionArray(this.props.activity)
    const resultsArr = sectionArr.resultsArr
    let nextSection = null

    _.each(resultsArr, function (section) {
      if (section.type === 'section' && section.cyuComplete !== true) {
        nextSection = section
        return false
      }
    })

    this.props.actions.closeCheckUnderstandingModal(activity, sectionArr)

    if (nextSection) this.onSelectReading(nextSection, true)
  }

  onSelectReading (section, cyuTopic = false) {
    if (!cyuTopic) {
      this.props.actions.readingSectionSelected(section)
    } else {
      this.props.actions.cyuSectionSelected(section)
      section.cyuTopic = this.props.activity.topics[`${section.topicIdInt}`]
    }

    this.setState({
      showVitalSourceEbook: true,
      selectedSection: section,
      selectedSelectionEbookUrl: section.ebookUrl
    })
  }

  onToggleVitalSourceEbook () {
    this.setState({
      showVitalSourceEbook: !this.state.showVitalSourceEbook
    })
  }

  onCloseVitalSourceEbook () {
    this.setState({
      showVitalSourceEbook: false,
      selectedTopic: null
    })
  }

  // Below are the instance methods for students who are reading before 1st quiz attempt
  renderReadingContainer () {
    const sectionArr = createSectionArray(this.props.activity)
    const finishedReading = sectionArr.sectionsRead === sectionArr.totalSections
    const isInProgress = isInProgressCheck(this.props.activity)
    const innerContentStyle = this.state.showVitalSourceEbook ? style.splitContent : style.innerContent
    let splitSmallStyle = ''
    if (this.props.browser.width <= 768 ||
      (this.state.showVitalSourceEbook && (this.state.splitLeftFooterWidth === '50%')) ||
      (this.state.showVitalSourceEbook && (window.innerWidth - this.state.splitLeftFooterWidth) <= 768)) {
      splitSmallStyle = (this.state.splitLeftFooterWidth !== '50%') &&
      (window.innerWidth - this.state.splitLeftFooterWidth <= 768)
        ? style.splitSmallContainer
        : ''
    }

    return (
      <Grid className={classnames(innerContentStyle, splitSmallStyle)}>
        <Row>
          <Col
            sm={this.state.showVitalSourceEbook || this.props.browser.width <= 768 ? 12 : 6}
            className={this.state.showVitalSourceEbook ? null : style.sectionContainer}
          >
            {(!finishedReading && !isInProgress)
              ? this.keepReadingPanel()
              : ((finishedReading && isInProgress) ? this.quizContinuePanel() : this.takeQuizPanel())}
          </Col>
          {!this.state.showVitalSourceEbook ? this.renderReadingSectionContainer() : null}
        </Row>
        <Row className={style.readingRow}>
          {this.state.showVitalSourceEbook ? this.renderReadingSectionContainer() : null}
        </Row>
      </Grid>
    )
  }

  keepReadingPanel () {
    return (
      <div className={panelStyle.base} data-test-id="keepReadingPanel">
        <h2 className={style.quizTitle}>Quiz</h2>
        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
          <object
            aria-hidden="true"
            data={lockImg} type="image/svg+xml"
            className={classnames(style.svgIcon, style.lockIcon)}
            tabIndex="-1"
          />
          <p className={style.quizInformation}>
            Read all the sections to unlock the quiz!
          </p>
        </div>
      </div>
    )
  }

  renderTakeQuizEstimatedTimeToComplete () {
    const { ffEstimatedTimeToCompleteEnabled, courseEstTime } = this.props
    return (
      ffEstimatedTimeToCompleteEnabled && courseEstTime > 0 &&
      <div className={style.estTimeToCompleteRow}>
        <span>Estimated Time to Complete:</span><span className={style.estTimeToComplete}>{courseEstTime != null ? `${courseEstTime}\u00A0min` : '--'}</span>
        <div>
          <RestrictableButton
            id="howIsCalculatedBtnId"
            clickEventHandler={() => this.setState({ howIsCalculatedModalOpen: true })}
            tabIndex={0}
            dataTestId="howIsCalculatedBtn"
            buttonText="How is this calculated?"
            ariaLabel="How is this calculated?"
            textButton
            whiteText
          />
        </div>
      </div>
    )
  }

  takeQuizPanel () {
    return (
      <AutoFocus>
        <div data-test-id="takeQuizPanel" className={classnames(panelStyle.finishedReadings, style.finishedReadings)}>
          <h2 className={style.finishedReadingsTitle}>Good job!</h2>
          <p className={style.quizMotivation}>
            Now that you have read the material, practice by taking the quiz!
          </p>
          <button
            className={classnames('btn-cdl-main', style.takeQuizButton)}
            tabIndex="0"
            onClick={this.startQuiz}
            onMouseHover={() => this.props.preload()}
          >
            <span
              data-test-id="beginActivityBtn"
              className={style.takeQuizButtonText}
            >
              Take the Quiz!
            </span>
          </button>
          {this.renderTakeQuizEstimatedTimeToComplete()}
        </div>
      </AutoFocus>
    )
  }

  setDocumentTitle () {
    const { activityTitle } = this.props.activity
    if (activityTitle) {
      document.title = `LearningCurve Read & Practice for ${activityTitle}`
    }
  }

  renderReadingSectionContainer () {
    const sectionArr = createSectionArray(this.props.activity)
    return (
      <Col
        sm={this.state.showVitalSourceEbook || this.props.browser.lessThan.medium ? 12 : 6}
        className={this.state.showVitalSourceEbook ? null : style.sectionContainer}
        aria-label="This is a group of readings you must complete in order to unlock the quiz."
      >
        <div className={panelStyle.base} >
          <span className={style.readingsHeader} data-test-id="numReadingsRemaining">
            {sectionArr.sectionsRead} of {sectionArr.totalSections} Readings Completed
          </span>
        </div>
        <div className={classnames(panelStyle.base, style.readingSection)} data-test-id="lcrpReadingSection">
          <fieldset>
            <legend />
            {this.renderReadingSections()}
          </fieldset>
        </div>
        <div className={classnames(panelStyle.base, style.readingSectionFooter)} />
      </Col>
    )
  }

  renderReadingSections () {
    const sectionArr = createSectionArray(this.props.activity)
    let excludedHeading = false

    let sectionReadingIndex = 0
    return sectionArr.resultsArr.map((result, index) => {
      let section

      if (result.type === 'section') {
        section = result
      } else if (result.type === 'heading') {
        return (
          <div
            key={index}
            className={style.sectionHeading}
            data-test-id={result.label}
          >
            {result.label}
          </div>
        )
      } else if (result.type === 'excluded_section') {
        // DEV NOTE: return everything here, don't pass anything to the general return statement below
        // this will prevent overlap and criss crossing mickey mouse bullshit
        section = result
        const sectionLabel = section.label + (excludedHeading ? '' : ' (not required)')
        return (
          <Row
            key={index}
            className={style.readingSectionRow}
            onClick={() => this.onSelectReading(section)}
            data-test-id="lcrpReadingItem"
            onMouseHover={() => LoadableLCRPSplitPane.preload()}
          >
            <Col xs={12} sm={9}>
              <input
                aria-label={section.label}
                className={style.readingCheckbox}
                disabled="disabled"
                type="checkbox"
                name="readingCheckbox"
                checked={false}
                id={section.label}
              />
              <label
                className={style.radio}
                htmlFor={section.label}
              >
                <span
                  className={style.disabledItem}
                  dangerouslySetInnerHTML={{ __html: sectionLabel }}
                  data-test-id="readingsTitles"
                />
              </label>
            </Col>
          </Row>
        )
      } else if (result.type === 'excluded_heading') {
        excludedHeading = true
        const labelHtml = result.label + ' <span className={style.disabledSectionHeading}>(not required)</span>'
        return (
          <div
            key={index}
            className={style.sectionHeading}
            data-test-id={`${result.label} (not required)`}
            dangerouslySetInnerHTML={{ __html: labelHtml }}
          />
        )
      }
      excludedHeading = false
      let sectionHtml
      if (this.state.selectedSection && section.sectionId === this.state.selectedSection.sectionId) {
        const sectionArr = createSectionArray(this.props.activity)
        const finishedReading = sectionArr.sectionsRead === sectionArr.totalSections
        if (finishedReading) {
          sectionHtml = (
            <span className={style.selectedItem} dangerouslySetInnerHTML={{ __html: section.label }} />
          )
        } else {
          sectionHtml = (
            <AutoFocus>
              <span className={style.selectedItem} dangerouslySetInnerHTML={{ __html: section.label }} />
            </AutoFocus>
          )
        }
      } else {
        sectionHtml = (
          <span className={style.topicItem} dangerouslySetInnerHTML={{ __html: section.label }} />
        )
      }

      sectionReadingIndex++
      const isReadingComplete = section.readingComplete
        ? 'Reading Complete'
        : 'Reading Incomplete. Click the checkbox to open the reading.'

      return (
        <Row
          key={index}
          onClick={() => this.onSelectReading(section)}
          className={style.readingSectionRow}
          data-test-id={`readingItem-${sectionReadingIndex}`}
          onMouseHover={() => LoadableLCRPSplitPane.preload()}
        >
          <Col xs={12} sm={9}>
            <input
              aria-label={`${isReadingComplete}: ${section.label}`}
              id={`reading-input-${index}`}
              className={style.readingCheckbox}
              type="checkbox"
              role="checkbox"
              name="readingCheckbox"
              checked={section.readingComplete}
              onChange={function (event) { event.target.checked = true }}
              onKeyDown={(event) => this.onKeyDown(event)}
            />
            <label
              className={style.radio}
              htmlFor={`reading-input-${index}`}
              aria-hidden="true"
            >
              {sectionHtml}
            </label>
          </Col>
        </Row>
      )
    })
  }

  // Below are the instance methods for students who have completed 1st attempt and need to review again
  renderCheckUnderstanding () {
    const isRetake = isRetakeCheck(this.props.activity)
    const isComplete =
      ((this.props.activity.score.activityScore >= this.props.activity.score.scoreTarget || isRetake ||
        (this.props.activity.score.activityScore === 0 && this.props.activity.lcrp.progress.HasTakenRetake)))

    return (
      <Grid className={this.state.showVitalSourceEbook ? style.splitContent : style.innerContent}>
        <Row>
          <Col
            sm={this.state.showVitalSourceEbook || this.props.browser.width <= 768 ? 12 : 6}
            className={this.state.showVitalSourceEbook ? null : style.sectionContainer}
          >
            {this.reviewToUnlockPanel()}
          </Col>
          {(!this.state.showVitalSourceEbook && isComplete) ? this.renderActivityResultsContainer() : null}
        </Row>
        <Row className={style.readingRow}>
          {(this.state.showVitalSourceEbook && isComplete) ? this.renderActivityResultsContainer() : null}
        </Row>
      </Grid>
    )
  }

  quizContinuePanel () {
    const isRetake = isRetakeCheck(this.props.activity)
    return (
      <div className={classnames(panelStyle.base, style.finishedReadings)}>
        <QuizProgressArea
          activityScore={this.props.activity.score.activityScore}
          scoreTarget={this.props.activity.score.scoreTarget}
          isRetake={isRetake}
        />
        <button
          className={classnames('btn-cdl-main', style.continueQuizButton)}
          tabIndex="0"
          onClick={this.startQuiz}
          onMouseHover={() => this.props.preload()}
        >
          <span>{isRetake ? 'Resume Practice Quiz' : 'Resume Quiz'}</span>
        </button>
      </div>
    )
  }

  reviewToUnlockPanel () {
    const sectionArr = createSectionArray(this.props.activity)
    const isInProgress = isInProgressCheck(this.props.activity)
    const isRetake = isRetakeCheck(this.props.activity)

    const quizLockedPanel = (
      <div
        data-test-id="quizLockedPanel"
        className={classnames(panelStyle.base, style.lockedPanel)}
      >
        <h3 className={style.quizTitle}>Quiz Done! Retake for Practice?</h3>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <object
            aria-label="read all sections to unlock quiz"
            data={lockImg} type="image/svg+xml"
            className={classnames(style.svgIcon, style.lockIcon)}
            tabIndex="-1"
          />
          <p className={style.quizInformation}>
            Reread and check your understanding on the sections you struggled with to unlock the practice quiz:
          </p>
        </div>
      </div>
    )
    const quizUnlockedPanel = (
      <div
        data-test-id="quizUnlockedPanel"
        className={classnames(panelStyle.base, panelStyle.finishedReadings, style.finishedReadings)}
      >
        <h2 className={style.finishedReadingsTitle}>Practice Quiz Unlocked!</h2>
        <p className={style.quizMotivation}>
          {'Now that you\'ve reread the sections you struggled with, ' +
          'practice what you\'ve learned by retaking the quiz.'}
        </p>
        <button
          data-test-id="retakeQuizBtn"
          className={classnames('btn-cdl-main', style.takeQuizButton)}
          tabIndex="0"
          onClick={this.startQuiz}
          onMouseHover={() => this.props.preload()}
        >
          <span className={style.takeQuizButtonText}>Retake the Quiz!</span>
        </button>
        {this.renderTakeQuizEstimatedTimeToComplete()}
      </div>
    )

    const checkUnderstandingTotal = sectionArr.cyuSectionsPassed + sectionArr.cyuSectionsRemaining
    const numReadingsRemaining = isInProgress ? checkUnderstandingTotal : sectionArr.cyuSectionsPassed

    const reviewToCompletePanel = (
      <div>
        <div className={panelStyle.base}>
          <Row>
            <Col
              sm={this.props.browser.width <= 768 ? 12 : 6}
              aria-label={'This is a group of readings.' +
              'Complete any check your understanding questions to unlock a retake quiz.'}
            >
              <span
                data-test-id="numReadingsRemaining"
                data-test-num={numReadingsRemaining}
                className={style.readingsHeader}
              >
                {numReadingsRemaining} of {checkUnderstandingTotal} Readings Completed
              </span>
            </Col>
          </Row>
        </div>
        <AutoFocus>
          <div className={classnames(panelStyle.base, style.readingsPanel)}>
            {this.renderReviewReadingSections(sectionArr.resultsArr)}
          </div>
        </AutoFocus>
      </div>
    )

    return (
      <div>
        {isInProgress
          ? this.quizContinuePanel()
          : (sectionArr.cyuSectionsRemaining === 0 ? quizUnlockedPanel : quizLockedPanel)}
        {isInProgress && !isRetake
          ? ''
          : reviewToCompletePanel
        }
      </div>
    )
  }

  renderReviewReadingSections (sections) {
    const sectionArray = createSectionArray(this.props.activity)
    let selectedSection
    if (this.state.selectedSection) {
      selectedSection = _.find(sectionArray.resultsArr, section => {
        return section.topicIdInt === this.state.selectedSection.topicIdInt &&
          section.sectionIdInt === this.state.selectedSection.sectionIdInt
      })
    }
    const isRetake = isRetakeCheck(this.props.activity)
    const isInProgress = isInProgressCheck(this.props.activity)
    let excludedHeading = false
    return sections.map((section, index) => {
      const reviewStyle = section.cyuComplete || isInProgress ? '' : style.reviewSection
      if (section.type === 'heading') {
        return (
          <div
            data-test-id={section.label}
            key={index}
            className={style.sectionHeading}
          >
            {section.label}
          </div>
        )
      } else if (section.type === 'excluded_section') {
        const sectionLabel = section.label + (excludedHeading ? '' : ' (not required)')
        return (
          <Row
            key={section.sectionId}
            onClick={() => this.onSelectReading(section, true)}
            className={classnames(style.readingSectionRow, reviewStyle)}
            onMouseHover={() => LoadableLCRPSplitPane.preload()}
          >
            <Col xs={12}>
              <input
                aria-label={section.label}
                className={style.readingReviewCheckbox}
                type="checkbox"
                disabled="disabled"
                name="readingCheckbox"
                checked={false}
                id={sectionLabel}
              />
              <label
                className={style.radio}
                htmlFor={sectionLabel}
              >
                <span className={style.disabledItem} dangerouslySetInnerHTML={{ __html: sectionLabel }} />
              </label>
            </Col>
          </Row>
        )
      } else if (section.type === 'excluded_heading') {
        excludedHeading = true
        const labelHtml = section.label + ' (not required)'
        return (
          <div
            data-test-id={`${section.label} (not required)`}
            key={index}
            className={style.disabledSectionHeading}
            dangerouslySetInnerHTML={{ __html: labelHtml }}
          />
        )
      }
      excludedHeading = false
      return (
        <Row
          key={section.sectionId}
          onClick={() => this.onSelectReading(section, true)}
          className={classnames(style.readingSectionRow, reviewStyle)}
          data-test-id="cyuReviewSection"
          onMouseHover={() => LoadableLCRPSplitPane.preload()}
        >
          <Col xs={12}>
            <input
              aria-label={`Click to open the reading: ${section.label}`}
              className={style.readingReviewCheckbox}
              type="checkbox"
              name="readingCheckbox"
              checked={section.cyuComplete || isInProgress}
              onKeyDown={(event) => this.onKeyDown(event)}
              tabIndex="0"
              id={section.label}
            />
            <label
              className={style.radio}
              htmlFor={section.label}
            >
              <span
                className={this.state.selectedSection && section.sectionId === this.state.selectedSection.sectionId
                  ? style.selectedItem
                  : style.topicItem}
                dangerouslySetInnerHTML={{ __html: section.label }}
              />
            </label>
            {isRetake && selectedSection && !selectedSection.cyuComplete && this.state.showVitalSourceEbook &&
              selectedSection.sectionId === section.sectionId && !isInProgress
              ? <button
                data-test-id="cyuButton"
                onClick={(event) => this.openCheckUnderstandingModal(selectedSection, event)}
                className={classnames('btn-cdl-main', style.understandingButton)}
                tabIndex="0"
              >
                <span>Check Your Understanding</span>
              </button>
              : null}
          </Col>
        </Row>
      )
    })
  }

  renderProgressBarArea (isRetake = false) {
    const pct = isRetake
      ? calculateRetakeAccuracy(this.props.activity)
      : calculateFirstAttemptAccuracy(this.props.activity)
    const retakeCurrentNum = this.props.activity.lcrp.progress.ra && this.props.activity.lcrp.progress.ra.length > 0
      ? this.props.activity.lcrp.progress.ra.length + 1
      : ''
    const desc = isRetake ? 'Practice Retake ' + retakeCurrentNum : 'Quiz Results'
    let topicArray

    if (isRetake && this.props.activity) {
      topicArray = this.props.activity.topics
    } else if (!isRetake && this.props.activity && this.props.activity.finalScore) {
      // this is not the retake chart, but a retake exists, so we need the first attempt topics
      topicArray = this.props.activity.finalScore.topics
    } else {
      topicArray = this.props.activity.topics
    }

    if (pct === false && !isInProgressCheck(this.props.activity)) {
      return false
    }

    return (
      <StudentProgressBar
        completedTimestamp={this.props.activity.completedTimestamp}
        topics={topicArray}
        pct={pct}
        desc={desc}
        retake={isRetake}
        onSelectReading={this.onSelectReading.bind(this)}
      />
    )
  }

  renderOldRetakeChartArea () {
    const activeTopics = this.props.activity.topics
    const oldRetakeArray = this.props.activity.lcrp.progress.ra
    let presentationTopicArray = []
    let topic = {}
    let pct = 0
    let i
    let retakeCount = 0

    if (oldRetakeArray.length > 0) {
      return oldRetakeArray.map((oldRetake, index) => {
        presentationTopicArray = []
        i = 0

        _.each(oldRetake.tp, function (oldRetakeTopic) {
          topic = {}

          topic.totalPointsEarned = oldRetakeTopic.pe
          topic.totalPointsAvailable = oldRetakeTopic.pa
          topic.questionsReceived = oldRetakeTopic.qr
          topic.totalQuestions = oldRetakeTopic.qr
          topic.label = activeTopics[i].label
          if (i < activeTopics.length - 1) {
            i++
          }

          presentationTopicArray.push(topic)
        })

        pct = getQuestionAccuracy(presentationTopicArray)
        retakeCount++
        return (
          <StudentProgressBar
            key={index}
            topics={presentationTopicArray}
            pct={pct}
            desc={'Practice Retake ' + retakeCount}
            retake={true}
            onSelectReading={this.onSelectReading.bind(this)}
          />
        )
      })
    } else {
      return false
    }
  }

  renderActivityResultsContainer () {
    return (
      <Col
        sm={this.state.showVitalSourceEbook || this.props.browser.width <= 768 ? 12 : 6}
        className={this.state.showVitalSourceEbook ? null : style.sectionContainer}
      >
        <div className={panelStyle.base}>
          <h3 className={style.quizTitle}>
            {"You've completed the assignment!"}
          </h3>
          <p className={style.greyLabel}>
            {'You can\'t change your grade, but you can deepen your knowledge ' +
            'by retaking the quiz for practice as many times as you like.'}
          </p>
        </div>
        {this.renderProgressBarArea()}
        {this.renderOldRetakeChartArea()}
        {this.renderProgressBarArea(true)}
      </Col>
    )
  }

  // Disiplay this if VitalSource ebook is open
  renderSplitPane () {
    const containerStyle = this.props.previewMode ? style.nextContainerPreview : style.nextContainer
    const nextUnreadSectionIdInt = this.state.selectedSection.sectionIdInt + 1
    const nextUnreadSection = getNextUnreadSectionById(this.props.activity, nextUnreadSectionIdInt)
      ? getNextUnreadSectionById(this.props.activity, nextUnreadSectionIdInt)
      : getNextUnreadSection(this.props.activity)

    const sectionArray = createSectionArray(this.props.activity)
    const selectedSection = _.find(sectionArray.resultsArr, section => {
      return section.topicIdInt === this.state.selectedSection.topicIdInt &&
        section.sectionIdInt === this.state.selectedSection.sectionIdInt
    })
    let bottomNavigation
    const isRetake = isRetakeCheck(this.props.activity)

    if (isRetake) {
      bottomNavigation = null
    } else {
      bottomNavigation = (
        <nav className={containerStyle}>
          <ul role="presentation">
            {nextUnreadSection
              ? (
              <li
                className={style.nextNavigation}
                onClick={() => this.onSelectReading(nextUnreadSection)}
                onKeyDown={(event) => this.onKeyDown(event)}
                tabIndex="0"
                role={'link'}
                dangerouslySetInnerHTML={{ __html: 'Next Section: ' + nextUnreadSection.label }}
                data-test-id="readingNextReadingBtn"
              />
                )
              : (
              <li
                className={style.nextNavigation}
                onClick={this.startQuiz}
                role={'link'}
                onKeyDown={(event) => this.onKeyDown(event)}
                tabIndex="0"
                data-test-id="readingTakeQuizBtn"
                onMouseHover={() => this.props.preload()}
              >
              Next: Take the Quiz!
              </li>
                )
            }
          </ul>
        </nav>
      )
    }

    return (
      <AutoFocus tabIndex="0">
        <LoadableLCRPSplitPane
          paneLabel={isRetake && !selectedSection.cyuComplete && selectedSection.type !== 'excluded_section'
            ? 'Check Your Understanding'
            : 'e-Book Section'
          }
          isLegacyEbook={false}
          url={this.props.consul.NODE_ENV === 'test' ? 'about:blank' : this.state.selectedSection.ebookUrl}
          isPreview={this.props.previewMode}
          browser={this.props.browser}
          label={this.state.selectedSection.label}
          actions={this.props.actions}
          toggle={this.onToggleVitalSourceEbook.bind(this)}
          footerContent={bottomNavigation}
          outerFooterCalc={this.onResizeSplit.bind(this)}
          lastWidth={this.state.splitLeftFooterWidth}
        >
          {(isRetake) ? this.renderCheckUnderstanding() : this.renderReadingContainer()}
        </LoadableLCRPSplitPane>
      </AutoFocus>
    )
  }

  renderDesktopNav () {
    const { headerStyle } = this.props.activity.config
    const isAchieve = headerStyle === 'achieve'
    if (isAchieve) {
      return (
        <Row className={baseStyle.topBarRow}>
          <Col xs={6} className={style.pageTitleContainer} />
          <Col xs={6} role="navigation">
            <button
              onClick={this.props.actions.tipsForSuccess}
              className={classnames('btn-cdl-secondary', style.headerButton)}
              tabIndex="0"
              data-test-id="studentTipsForSuccess"
            >
              <span className={style.hide768}>Tips for Success</span>
              <span className={style.show768}>Tips</span>
            </button>
            <button
              onClick={this.openStudentInsights}
              className={classnames('btn-cdl-main', style.insightsButton)}
              data-test-id="studentTrendsAndInsights"
              onMouseHover={() => LoadableStudentInsights.preload()}
            >
              Trends and Insights
            </button>
          </Col>
        </Row>
      )
    }
    return (
      <Row className={baseStyle.topBarRow}>
        <Col xs={6} className={style.pageTitleContainer}>
          <h1
            data-test-id="logoRow"
            className={style.logoRow}
            tabIndex="0"
            style={{ fontSize: this.props.browser.lessThan.medium ? 14 : 18 }}
          >
            <TextTruncate
              text={this.props.activity.activityTitle}
              line={2}
              browser={this.props.browser}
            />
          </h1>
        </Col>
        <Col xs={6} role="navigation">
          <button
            onClick={this.props.actions.tipsForSuccess}
            className={classnames('btn-cdl-main', style.headerButton)}
            tabIndex="0"
            data-test-id="studentTipsForSuccess"
          >
            <span className={style.hide768}>Tips for Success</span>
            <span className={style.show768}>Tips</span>
          </button>
          <span
            onClick={this.openStudentInsights}
            className={style.insightsLink}
            data-test-id="studentTrendsAndInsights"
            onMouseHover={() => LoadableStudentInsights.preload()}
          >
            My Trends & Insights
          </span>
        </Col>
      </Row>
    )
  }

  renderMobileNav () {
    return (
      <Col xs={6}>
        <MobileNavDropdown
          openInsights={this.openStudentInsights}
          tipsForSuccess={this.props.actions.tipsForSuccess}
        />
      </Col>
    )
  }

  renderTopBar () {
    const { width } = this.props.browser
    const isMobile = width < 769
    const { headerStyle } = this.props.activity.config
    const isAchieve = headerStyle === 'achieve'
    return (
      <TopBar
        headerStyle={headerStyle}
        isPreview={this.props.previewMode}
      >
        {!isAchieve && <CloseX closeAction={this.props.actions.closeActivity} />}
        <Grid className={classnames(baseStyle.topBarWrapper)}>
          {isMobile ? this.renderMobileNav() : this.renderDesktopNav()}
        </Grid>
      </TopBar>
    )
  }

  render () {
    this.setDocumentTitle()
    const { width } = this.props.browser
    const isMobile = width < 769
    const { activity } = this.props
    const previewStyle = this.props.previewMode ? style.previewStyle : ''

    if (this.props.browser.width <= 768 && this.state.showVitalSourceEbook) {
      const nextUnreadSectionIdInt = this.state.selectedSection.sectionIdInt + 1
      let nextUnreadSection = getNextUnreadSectionById(activity, nextUnreadSectionIdInt)
        ? getNextUnreadSectionById(activity, nextUnreadSectionIdInt)
        : getNextUnreadSection(activity)

      const sectionArray = createSectionArray(this.props.activity)
      const selectedSection = _.find(sectionArray.resultsArr, section => {
        return section.topicIdInt === this.state.selectedSection.topicIdInt &&
          section.sectionIdInt === this.state.selectedSection.sectionIdInt
      })
      const isRetake = isRetakeCheck(this.props.activity)

      // PropTypes in below component expects an object, not a boolean
      if (nextUnreadSection === false) {
        nextUnreadSection = { takeQuiz: true }
      }
      const cyuModalView = (
        <CheckYourUnderstandingModal
          actions={this.props.actions}
          activity={this.props.activity}
          fetchQuestion={this.props.actions.fetchQuestion}
          onNext={this.loadNextCyuSection}
          onCancel={this.closeCheckUnderstandingModal}
          selectedSection={this.state.selectedSection}
        />
      )
      return (
        <AssignmentReadingMobile
          onClick={this.onCloseVitalSourceEbook.bind(this)}
          data={this.state.selectedSection.ebookUrl}
          isCYU={selectedSection.cyuComplete || selectedSection.readingComplete}
          assignmentTitle={selectedSection.cyuComplete || selectedSection.readingComplete ||
            selectedSection.type === 'excluded_section'
            ? 'e-Book Section'
            : 'Check Your Understanding'}
          nextUnreadSection={nextUnreadSection}
          onNextItem={() => this.onSelectReading(nextUnreadSection)}
          readingIncomplete={this.props.activity.lcrp.readCount < this.props.activity.topics.length}
          startQuiz={this.startQuiz}
          score={this.props.activity.score}
          openCheckUnderstandingModal={(event) => this.openCheckUnderstandingModal(selectedSection, event)}
          cyuModalView={cyuModalView}
          isQuestionVisible={this.props.uiState.showCheckYourUnderstandingModal}
          sections={sectionArray}
          retake={isRetake}
          selectedSection={this.state.selectedSection}
        />
      )
    }
    // Check if student has finished a quiz or not
    if (!this.props.activity.score) return null
    const isRetake = isRetakeCheck(this.props.activity)
    const renderedContainer = (isRetake)
      ? this.renderCheckUnderstanding.bind(this)
      : this.renderReadingContainer.bind(this)

    if (this.state.showInsights) {
      return (
        <LoadableStudentInsights
          browser={this.props.browser}
          isMobile={isMobile}
          courseDashboardData={this.props.courseDashboardData}
          closeInsights={() => { this.setState({ showInsights: false }) }}
          initialUserData={this.props.initialUserData}
          previewMode={this.props.previewMode}
          loadLCRPActivityState={this.props.actions.loadLCRPActivityState}
          config={this.props.activity.config}
        />
      )
    }

    return (
      <div className={classnames(style.container, previewStyle)}>
        {this.renderTopBar()}
        <div {...(this.props.activity.config.headerStyle !== 'achieve' ? { role: 'main' } : {})}>
          {this.state.showVitalSourceEbook ? this.renderSplitPane() : renderedContainer()}
          {this.props.uiState.showCheckYourUnderstandingModal
            ? <CheckYourUnderstandingModal
              actions={this.props.actions}
              activity={this.props.activity}
              fetchQuestion={this.props.actions.fetchQuestion}
              onNext={this.loadNextCyuSection}
              onCancel={this.closeCheckUnderstandingModal}
              selectedSection={this.state.selectedSection}
            />
            : null
          }
          {this.state.displayModal &&
            <PreviewAsStudentModal
              onCancel={() => { this.setState({ displayModal: false }) }}
            />
          }
          {this.state.howIsCalculatedModalOpen && <HowIsCalculatedModal
            type={'Estimated'}
            onClose={() => this.setState({ howIsCalculatedModalOpen: false })}
          />}
        </div>
      </div>
    )
  }
}

AssignmentReading.propTypes = {
  activity: PropTypes.object,
  uiState: PropTypes.object,
  actions: actionProptypes,
  browser: PropTypes.object,
  isSimulateRetake: PropTypes.string,
  previewMode: PropTypes.string,
  onStartQuiz: PropTypes.func,
  courseDashboardData: PropTypes.object,
  initialUserData: PropTypes.object,
  consul: PropTypes.object,
  preload: PropTypes.func,
  ffEstimatedTimeToCompleteEnabled: PropTypes.bool,
  courseEstTime: PropTypes.number,
  courseAvgTime: PropTypes.number
}
